import { useTranslation } from "react-i18next";
import { Button, Card } from "antd";
import { CURRENCY } from "../../../../../constants/DeliveryConstants";
import { formatPrice } from "../../../../../functions/formatters";
import HorizontalBarChart from "../../../../../components/shared-components/HorizontalBarChart";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { customersReport } from "../../../../../urls";

const TopCustomers = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSeeFullReport = () => {
    const currentParams = searchParams.toString();
    navigate(`${customersReport}${currentParams ? `?${currentParams}` : ""}`);
  };

  if (!data || !data.customers || data.customers.length === 0) {
    return (
      <Card
        title={t("top_customers")}
        extra={
          <Button type="link" onClick={handleSeeFullReport}>
            {`${t("see_full_report")} →`}
          </Button>
        }
      >
        <span className="text-muted">{data?.readableDateRange || ""}</span>
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <span className="text-muted">{t("no_data_available")}</span>
        </div>
      </Card>
    );
  }

  const series = [
    {
      name: t("revenue"),
      data: data.customers.map((customer) => customer.totalRevenue),
    },
  ];

  const categories = data.customers.map((customer) => customer.name);

  const formatValue = (val) => CURRENCY + formatPrice(val);

  return (
    <Card
      title={t("top_customers")}
      extra={
        <Button type="link" onClick={handleSeeFullReport}>
          {t("see_full_report")}
        </Button>
      }
    >
      <span className="text-muted">{data.readableDateRange}</span>
      <HorizontalBarChart series={series} categories={categories} height={300} formatValue={formatValue} />
    </Card>
  );
};

export default TopCustomers;
